import { Theme } from '@mui/material/styles';
import { TWidget } from '../../utility/types/dataProvider';

export const widgetCardStyle = (
  theme: Theme,
  isIndependentSystemWidget: boolean,
  systemModule: TWidget['module']['id'],
) => {
  const isLightTheme = theme.palette.mode === 'light';
  const isHelpWidget = isIndependentSystemWidget && systemModule === 'help';
  const helpWidgetBgColor = isLightTheme
    ? theme.blox.colors.gray5
    : theme.blox.colors.offblack;
  const backgroundColor = isHelpWidget
    ? helpWidgetBgColor
    : isLightTheme
      ? theme.blox.colors.white
      : theme.blox.colors.offblack;

  return {
    backgroundColor,
    mb: { xs: 1 },
    overflow: 'visible',
    boxShadow: 0,
    border: `1px solid ${theme.palette.divider}`,
    '& .MuiCardContent-root': {
      overflow: 'visible',
    },

    '& .widget-header': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      mb: 2,
      position: 'relative',
      zIndex: 1,
    },
  };
};

export const dashboardDialogStyles = (theme: Theme) => ({
  '.MuiDialog-paper': {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    padding: 2,
  },
  '.MuiDialogContent-root': {
    padding: 0,
  },
  '& .dialog-header': {
    display: 'flex',
    justifyContent: 'space-between',
  },
});
